// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"13":"de272136","279":"546a5dd4","502":"dec4c112","748":"3f943535","874":"94b94e81","918":"5dbf8b78"}[chunkId] + ".chunk.css";
};